import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, Observable, tap} from "rxjs";
import {
  ActionResult,
  ActionResultList,
  EventItem, FetchEventByIdRequest,
  FetchRaceByIdRequest,
  LiveResult, PagedFilter, Race
} from "@model";
import {LoaderService} from "./loader.service";
import {LiveResultFilter} from "../model/live-result-filter";
import {EnvironmentService} from "./environment.service";

@Injectable({providedIn: 'root'})
export class LiveResultsService {

  constructor(private http: HttpClient, private loaderService: LoaderService, private environmentService:EnvironmentService) {
  }

  fetchLiveEvents(hideLoading?: boolean): Observable<EventItem[] | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.get<ActionResultList<EventItem[], number>>(this.environmentService.getApiUrl() + "/api/public/live/events").pipe(tap(() => {
      if (!hideLoading) {
        this.loaderService.dismissLoading()
      }
    }), map((value: ActionResultList<EventItem[], number>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }

  fetchLiveResults(filter: PagedFilter<LiveResultFilter>, hideLoading?: boolean): Observable<LiveResult | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResult<LiveResult>>(this.environmentService.getApiUrl() + "/api/public/live/results", filter)
      .pipe(tap(() => {
        if (!hideLoading) {
          this.loaderService.dismissLoading()
        }
      }), map((value: ActionResult<LiveResult>) => {
        if (value && value.result) {
          return value.result;
        } else {
          return null;
        }
      }));
  }

  fetchLiveEvent(eventId: FetchEventByIdRequest, hideLoading?: boolean): Observable<EventItem | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResult<EventItem>>(this.environmentService.getApiUrl() + "/api/public/live/event", eventId)
      .pipe(
        tap(() => {
          if (!hideLoading) {
            this.loaderService.dismissLoading()
          }
        }),
        map((value: ActionResult<EventItem>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return null;
          }
        })
      );
  }

  fetchLiveRace(raceRequest: FetchRaceByIdRequest, hideLoading?: boolean): Observable<Race | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResult<Race>>(this.environmentService.getApiUrl() + "/api/public/live/race", raceRequest)
      .pipe(
        tap(() => {
          if (!hideLoading) {
            this.loaderService.dismissLoading()
          }
        }),
        map((value: ActionResult<Race>) => {
          if (value && value.result) {
            return value.result;
          } else {
            return null;
          }
        })
      );
  }
}

